export const ACC_SALDO_PERIOD_TAB = 'ACC_SALDO_PERIOD_TAB';